export enum MOBILE_STEPS {
  MORE_FILTERS = 'more-filters',
  SELECTED_USERS = 'selected-users',
  USERS_LIST = 'users-list',
}
